import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { CleanVoiceInterface } from '../components/voice/CleanVoiceInterface';
import ChatLayout from '../components/chat/layout/ChatLayout';
import { ChatInterfaceProvider } from '../contexts/ChatInterfaceContext';

const VoiceChatOpenAI: React.FC = () => {
  const { positId } = useParams<{ positId: string }>();
  const navigate = useNavigate();

  const handleEndCall = () => {
    navigate(`/chat/${positId}`);
  };

  if (!positId) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
        <div className="text-red-600 text-lg mb-4">Invalid Posit ID</div>
        <button 
          onClick={() => navigate('/')} 
          className="px-6 py-3 bg-primary text-primary-foreground rounded-[var(--radius)] hover:bg-primary/90 transition-colors"
        >
          Go Home
        </button>
      </div>
    );
  }

  return (
    <ChatInterfaceProvider>
      <ChatLayout 
        mobileTitle="Voice Chat (OpenAI)"
        showMobileHeader={false}
      >
        <CleanVoiceInterface 
          positId={positId} 
          onEndCall={handleEndCall}
        />
      </ChatLayout>
    </ChatInterfaceProvider>
  );
};

export default VoiceChatOpenAI;